import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderDetailsService {
  private orderDetailsSubject = new BehaviorSubject<any>(null);
  public orderDetails$ = this.orderDetailsSubject.asObservable();

  private formValuesSubject = new BehaviorSubject<any>(this.loadFormValues());
  public formValues$ = this.formValuesSubject.asObservable();

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url !== '/sandbox') {
          this.clearSearchData();
        }
      }
    });
  }

  private loadFormValues() {
    const savedFormValues = sessionStorage.getItem('orderFormValues');
    return savedFormValues ? JSON.parse(savedFormValues) : {};
  }

  setOrderDetails(details: any) {
    this.orderDetailsSubject.next(details);
    sessionStorage.setItem('orderDetails', JSON.stringify(details));
  }

  getOrderDetails() {
    const storedOrderDetails = sessionStorage.getItem('orderDetails');
    if (storedOrderDetails) {
      return JSON.parse(sessionStorage.getItem('orderDetails') || '{}');
    }
    return this.orderDetailsSubject.getValue();
  }

  setFormValues(values: any) {
    this.formValuesSubject.next(values);
    sessionStorage.setItem('orderFormValues', JSON.stringify(values));
  }

  getFormValues() {
    const savedValues = sessionStorage.getItem('orderFormValues');
    return savedValues ? JSON.parse(savedValues) : {};
  }

  private clearSearchData() {
    sessionStorage.removeItem('orderFormValues');
    sessionStorage.removeItem('orderDetails');
    this.formValuesSubject.next({});
    this.orderDetailsSubject.next(null);
  }
}
